<template>
  <div id="member-list">
    <article 
      class="message" 
      :class="{'is-success': message.success, 'is-danger': message.error}"
      v-if="message.success || message.error"
    >
      <div class="message-header">
        <p>{{ message.title }}</p>
        <button 
          class="delete" 
          aria-label="delete"
          @click="message.success=false; message.error=false"
        ></button>
      </div>
      <div class="message-body">
        {{ message.body }}
      </div>
    </article>
    <div class="modal" v-bind:class="{ 'is-active': isActive }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="card">
          <div class="card-header">
            <div class="card-header-title">
              {{ fullName }}
            </div>
          </div>
          <div class="card-content">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Branch</label>
              </div>
               <div class="field-body">
                 <div class="field is-narrow">
                   <div class="control">
                     <div class="select">
                       <select v-model="branch">
                         <option value=""></option>
                         <option v-for="b in branches" :key="b">{{ b }}</option>
                       </select>
                     </div>
                   </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Rank</label>
              </div>
               <div class="field-body">
                 <div class="field is-narrow">
                   <div class="control">
                     <div class="select">
                       <select v-model="grade" v-if="branch !== ''" :key="rmnId">
                         <option></option>
                         <option 
                           v-for="r in ranks" 
                           :key="branch+r.grade"
                           :value="r.grade"
                         >
                           {{ r.rank }}
                         </option>
                       </select>
                       <select disabled v-else>
                         <option>Select a branch</option>
                       </select>
                     </div>
                   </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">First Name</label>
              </div>
               <div class="field-body">
                 <div class="field">
                   <div class="control">
                     <input class="input" v-model="firstName" placeholder="First Name" />
                   </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Last Name</label>
              </div>
               <div class="field-body">
                 <div class="field">
                   <div class="control">
                     <input class="input" v-model="lastName" placeholder="Last Name" />
                   </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">RMN ID</label>
              </div>
               <div class="field-body">
                 <div class="field">
                   <div class="control">
                     <input class="input" v-model="rmnId" placeholder="RMN-9999-99" />
                   </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Email</label>
              </div>
               <div class="field-body">
                 <div class="field">
                   <div class="control">
                     <input class="input" v-model="email" placeholder="johndoe@here.com" />
                   </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Discord ID</label>
              </div>
               <div class="field-body">
                 <div class="field">
                   <div class="control">
                     <input class="input" v-model="discord_id" placeholder="409747021990199296" />
                   </div>
                </div>
              </div>
            </div>

          </div>
          <footer class="modal-card-foot">
            <button class="button is-success" @click="save">
              {{ add ? 'Add Member' : 'Save Member' }}
            </button>
            <button class="button" @click="close">Cancel</button>
          </footer>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="close"></button>
    </div>
    <div class="page-head">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title">
              Personnel List
            </p>
          </div>
        </div>

        <div class="level-right">
          <div class="level-item">
            <button class="button is-success" @click="launch(null)">
              <span class="icon">
                <i class="fas fa-plus"></i>
              </span>
              <span>Add Member</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Member</th>
          <th>RMN ID</th>
          <th>Current Position(s)</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m in memberList" :key="m.rmn_id">
          <td>
            <nobr>{{ rank(m.branch, m.rank) }} {{ m.first_name }} {{ m.last_name }}, {{ m.branch }}</nobr></td>
          <td>
            <nobr><router-link :to="'/member/'+m.rmn_id">{{ m.rmn_id }}</router-link></nobr>
          </td>
          <td>
            <router-link 
              :to="'/position/' + p.position._id" 
              v-for="p in positions(m)" 
              :key="p._id">
                {{ p.position.display_name }}<br />
            </router-link>
          </td>
          <td>
            <button 
              class="button is-danger is-small"
              @click="launch(m.rmn_id)"
            >
              Edit
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th>Member</th>
          <th>RMN ID</th>
          <th>Positions</th>
          <th></th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import MEMBERLIST from '@/gql/memberlist'
import ADD_MEMBER from '@/gql/addmember'
import { rankMatrix } from '@/components/rankMatrix'

export default {
  data () {
    return {
      isActive: false,
      branch: '',
      grade: '',
      firstName: '',
      lastName: '',
      email: '',
      rmnId: '',
      discord_id: '',
      // eslint-disable-next-line
      _id: '',
      add: true,
      message: {
        title: '',
        body: '',
        success: false,
        error: false
      },
      rankMatrix: rankMatrix
    }
  },
  methods: {
    launch (id) {
      if (id && id !== '') {
        this.add = false
        let member = this.memberList.filter((a) => {
          return a.rmn_id === id
        })[0]
        this.firstName = member.first_name
        this.lastName = member.last_name
        this.rmnId = member.rmn_id
        this.branch = member.branch
        this.grade = member.rank
        this.email = member.email
        this.discord_id = member.discord_id
        this._id = member._id
      }
      this.isActive = true
    },
    close () {
      this.branch = ''
      this.grade = ''
      this.firstName = ''
      this.lastName = ''
      this.email = ''
      this.rmnId = ''
      this.discord_id = ''
      this.add = true
      this.isActive = false
    },
    save () {
      // console.log(`Saving ${this.rmnId}...`)
      this.$apollo.mutate({
        mutation: ADD_MEMBER,
        variables: {
          fname: this.firstName,
          lname: this.lastName,
          rmnid: this.rmnId,
          branch: this.branch,
          rank: this.grade,
          email: this.email,
          discord_id: this.discord_id
        },
        optimisticResponse: {
          __typename: 'Mutation',
          addUpdateMember: {
            __typename: 'Member',
            // eslint-disable-next-line
            _id: this.add ? 0 : this._id,
            rmn_id: this.rmnId,
            first_name: this.firstName,
            last_name: this.lastName,
            branch: this.branch,
            email: this.email,
            rank: this.grade,
            history: null,
            awards: null
          }
        },
        update: (store, { data: { addUpdateMember } }) => {
          const data = store.readQuery({ query: MEMBERLIST })

          var m = data.members.find(x => x.rmn_id === this.rmnId) 

          if (!m) {
            m = {}
          }
          // console.log(`M? ${JSON.stringify(m)}`)
          if (this.add) {
            m._id = addUpdateMember._id
            m.awards = []
            m.history = []
          }
          m.first_name = addUpdateMember.first_name
          m.last_name = addUpdateMember.last_name
          m.rank = addUpdateMember.rank
          m.branch = addUpdateMember.branch
          m.email = addUpdateMember.email
          m.awards = addUpdateMember.awards
          m.history = addUpdateMember.history
          // console.log(`FOUND ${JSON.stringify(m)}`)

          if (this.add) {
            data.members.push(m)
          }

          store.writeQuery({ query: MEMBERLIST, data })
        }
      }).then(() => {
        // console.log(`ADD_MEMBER ${data}`)
        this.message.title = 'Success!'
        this.message.body = 'Data saved successfully'
        this.message.error = false
        this.message.success = true
      }).catch((err) => {
        // console.log(`ADD_MEMBER ERROR ${err}`)
        this.message.title = 'Uh oh!'
        this.message.body = err
        this.message.success = false
        this.message.error = true
      })
      this.close()
    },
    rank (branch, grade) {
      return rankMatrix[branch][grade]
    },
    positions (member) {
      if (!member.history) { return [] }
      var p = member.history.slice().filter((pos) => {
        return pos.started && !pos.left
      })
      return p
    }
  },
  computed: {
    fullName () {
      let name = `${this.firstName} ${this.lastName}`
      if (name !== ' ') {
        return name
      }

      return 'New Member'
    },
    branches () {
      return Object.keys(rankMatrix)
    },
    ranks () {
      if (this.branch !== '') {
        let obj = rankMatrix[this.branch]
        var result = []
        for (var k in obj) {
          result.push({ grade: k, rank: obj[k] })
        }
        return result
      }

      return []
    },
    memberList () {
      if (!this.members) {
        return []
      }

      var m = this.members.slice().sort((a, b) => {
        var primary = a['last_name'].localeCompare(b['last_name'])
        var secondary = a['first_name'].localeCompare(b['first_name'])
        return primary == 0 ? secondary : primary
      })

      return m
    }
  },
  beforeRouteEnter (to, from, next) { 
    next(vm => { 
      let perms = vm.$store.state.user.permissions
      if (vm.$store.state.user.token !== '' &&
          perms && 
          (perms.indexOf('ADMIN') > -1 || 
          perms.indexOf('MEMBERS') > -1)) {
        next()
      } else {
        next('/academy/admin')
      }
    }) 
  },
  apollo: {
    members: {
      query: MEMBERLIST,
    }
  }
}
</script>

<style scoped>
.page-head {
  border-bottom: 1px solid black;
  margin-top: 10px;
  padding-bottom: 10px;
}
</style>
